// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"uXEdS"};